import { observable } from "mobx";
import { Transform } from "class-transformer";
import formatISO from "date-fns/formatISO";
import { Expose } from "class-transformer";
import BannerListItemType from "./bannerListItemType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class BannerListItem {
  /**
   * Banner Id
   */
  id!: number;

  @observable
  title!: string;

  @observable
  type!: BannerListItemType;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "valid_from" })
  validFrom?: Date;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "valid_to" })
  validTo?: Date;

  static ValidationRules = {
    id: { required: true, number: true },
    title: { maxLength: 255, required: true },
    type: { required: true },
    validFrom: { date: true },
    validTo: { date: true },
  };
}
